import React, {Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import {I18nextProvider} from 'react-i18next';
import {createBrowserHistory} from 'history';
import {Router} from 'react-router-dom';
import i18n from './i18n';
import App from 'components/App/App';

import Spinner from 'components/Spinner/Spinner';

const history = createBrowserHistory();
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18n}>
    <Router history={history}>
      <Suspense fallback={<Spinner/>}>
        <App/>
      </Suspense>
    </Router>
  </I18nextProvider>,
);
